import React, { Dispatch, SetStateAction, useState } from "react";
import DeletePopUp from "../DeletePopUp";
import { Pencil } from "lucide-react";
import {
  renderTableExistingFilePreview,
  renderTableFilePreview,
} from "../../exports/functions";
import { ICommitteeMemberInput } from "../../exports/interfaces";

const CommiteeTable = ({
  committeeData,
  setCommitteeCooperative,
  setEditCommitteeIndex,
  editCommitteeIndex,
  setCommitteeTableCooperative,
}: {
  committeeData: ICommitteeMemberInput[];
  setCommitteeCooperative: Dispatch<SetStateAction<ICommitteeMemberInput>>;
  setEditCommitteeIndex: Dispatch<SetStateAction<number | null>>;
  editCommitteeIndex: number | null;
  setCommitteeTableCooperative: Dispatch<
    SetStateAction<ICommitteeMemberInput[]>
  >;
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const handleClose = () => {
    setShowDelete(false);
    setDeleteIndex(null);
  };

  const handleDelete = () => {
    if (deleteIndex === null) return;

    setCommitteeTableCooperative((prev) =>
      prev.filter((_, i) => i !== deleteIndex),
    );

    if (editCommitteeIndex === deleteIndex) {
      setEditCommitteeIndex(null);
      setCommitteeCooperative({
        committeeType: "",
        position: "",
        positionStatus: "",
        grandmotherName: "",
        fatherName: "",
        maritalStatus: "",
        husbandName: "",
        fullName: "",
        gender: "",
        mobile: "",
        email: "",
        address: "",

        citizenship: "",
        pan: "",
        nid: "",
        issuedDistrict: "",
        tenureStart: "",
        tenureEnd: "",

        province: "",
        district: "",
        municipality: "",
        ward: null,
        street: "",

        education: "",
        file: null,
        fileName: "",
        bodFile: null,
        bodFileName: "",
        citizenshipFront: null,
        citizenshipFrontName: "",
        citizenshipBack: null,
        citizenshipBackName: "",
      });
    } else if (
      editCommitteeIndex !== null &&
      editCommitteeIndex > deleteIndex
    ) {
      // Update edit index after deleting an item before it
      setEditCommitteeIndex(editCommitteeIndex - 1);
    }

    setDeleteIndex(null);
    setShowDelete(false);
  };
  return (
    <>
      <div className="dashboard-card mt-3">
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Photo</th>
                <th>Committee Type</th>
                <th>Position</th>
                <th>Full Name</th>
                <th>Education</th>
                <th>Email</th>
                <th className="sticky-action">Actions</th>
              </tr>
            </thead>

            <tbody>
              {committeeData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  <td>
                    {item.file
                      ? renderTableFilePreview(item.file, item.fileName)
                      : item.documentUrl
                        ? renderTableExistingFilePreview(item.documentUrl)
                        : null}
                  </td>

                  <td>{item.committeeType}</td>
                  <td>{item.position}</td>
                  <td>{item.fullName}</td>
                  <td>{item.education}</td>
                  <td>{item.email}</td>

                  <td className="sticky-action">
                    <div className="d-flex gap-2 align-items-center">
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit"
                      >
                        <Pencil
                          size={20}
                          onClick={() => {
                            setCommitteeCooperative({
                              ...item,
                            });

                            setEditCommitteeIndex(index);
                          }}
                        />
                      </i>
                      <i
                        className="fa-solid fa-trash text-danger cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete"
                        onClick={() => {
                          setDeleteIndex(index);
                          setShowDelete(true);
                        }}
                      ></i>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showDelete && (
        <DeletePopUp onClose={handleClose} onConfirm={handleDelete} message="This item will be marked for deletion and will be permanently deleted only after you save your changes"/>
      )}
    </>
  );
};

export default CommiteeTable;
